"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentCollectionReferenceSchema = void 0;
exports.ContentCollectionReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/content/collections.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ContentCollectionReference",
    "description": "A content collection aggregates content based on tags content was tagged with.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:master:collections"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sbGVjdGlvbnMuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvcmVmZXJlbmNlL2NvbnRlbnQvY29sbGVjdGlvbnMuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsZ0NBQWdDLEdBQUc7SUFDOUMsS0FBSyxFQUFFLDJFQUEyRTtJQUNsRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSw0QkFBNEI7SUFDckMsYUFBYSxFQUFFLGdGQUFnRjtJQUMvRixNQUFNLEVBQUUsUUFBUTtJQUNoQixVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sSUFBSTtLQUNMO0lBQ0QsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFO2dCQUNOLHdCQUF3QjthQUN6QjtZQUNELE1BQU0sRUFBRSxRQUFRO1NBQ2pCO1FBQ0QsSUFBSSxFQUFFO1lBQ0osTUFBTSxFQUFFLFFBQVE7WUFDaEIsU0FBUyxFQUFFLDZFQUE2RTtTQUN6RjtLQUNGO0NBQ0YsQ0FBQSJ9